import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useCoursePartnerList = (params?: any) => {
  return useQuery({
    queryKey: ['course-partner-list', params],
    queryFn: async () => {
      const res = await request.get('/course-partner', { params });
      return res.data;
    }
  });
};
